<style>
      .tiptap .ProseMirror,
      .ProseMirror {
        caret-color: #111827;
        font-size: calc(12px * var(--fontScaleRatio, 1) * var(--editorDeviceScale, 1));
        /* line-height intentionally omitted: block-typography extension sets it per block */
      }


      /* Remove constant line-height for block elements so block-typography can set it */
      /* .tiptap .ProseMirror p,
      .tiptap .ProseMirror li,
      .tiptap .ProseMirror blockquote,
      .tiptap .ProseMirror td,
      .tiptap .ProseMirror th,
      .ProseMirror p,
      .ProseMirror li,
      .ProseMirror blockquote,
      .ProseMirror td,
      .ProseMirror th {
        line-height: 1.35;
      } */

      .tiptap .ProseMirror span[style*="font-size"],
      .ProseMirror span[style*="font-size"] {
        line-height: 1.2 !important;
      }

      .tiptap.ProseMirror h1,
      .tiptap .ProseMirror h1,
      .ProseMirror h1 {
        display: block !important;
        font-size: 2em !important;
        font-weight: 800 !important;
        line-height: 1.2 !important;
        margin: 0.6em 0 0.35em !important;
      }

      .tiptap.ProseMirror h2,
      .tiptap .ProseMirror h2,
      .ProseMirror h2 {
        display: block !important;
        font-size: 1.5em !important;
        font-weight: 750 !important;
        line-height: 1.25 !important;
        margin: 0.55em 0 0.3em !important;
      }

      .tiptap.ProseMirror h3,
      .tiptap .ProseMirror h3,
      .ProseMirror h3 {
        display: block !important;
        font-size: 1.25em !important;
        font-weight: 700 !important;
        line-height: 1.3 !important;
        margin: 0.5em 0 0.25em !important;
      }

      .tiptap .ProseMirror img,
      .ProseMirror img,
      .tiptap-image-node__img {
        max-width: 100% !important;
        height: auto !important;
        object-fit: contain;
      }

      /* Image drag & drop: drop-target highlight while files are dragged over the editor */
      .tiptap.is-file-dragover {
        outline: 2px dashed var(--primary-color, #3b82f6);
        outline-offset: -2px;
        background-color: color-mix(in srgb, var(--primary-color, #3b82f6) 6%, transparent);
      }

      /* Image drag & drop: inline marker where pending images will be inserted */
      .tiptap-image-drop-placeholder {
        display: inline-flex;
        align-items: center;
        gap: 0.4em;
        margin: 0.15em 0;
        padding: 0.2em 0.6em;
        border-radius: 0.375rem;
        border: 1px dashed currentColor;
        font-size: 0.9em;
        opacity: 0.7;
        user-select: none;
        pointer-events: none;
      }

      @media (max-width: 767.98px) {
        .tiptap .ProseMirror img,
        .ProseMirror img,
        .tiptap-image-node__img {
          max-width: 100% !important;
          height: auto !important;
        }

        /* ── Editor container: reduce outer left/right/top/bottom padding ~75% ── */
        .tiptap {
          padding-left: 0.375rem !important;
          padding-right: 0.2rem !important;
          padding-top: 0.25rem !important;
          padding-bottom: 0.25rem !important;
          min-height: 80px !important;
        }

        /* ── Headings: reduce top/bottom margins ~75% ── */
        .tiptap.ProseMirror h1,
        .tiptap .ProseMirror h1,
        .ProseMirror h1 {
          margin: 0.15em 0 0.09em !important;
        }

        .tiptap.ProseMirror h2,
        .tiptap .ProseMirror h2,
        .ProseMirror h2 {
          margin: 0.14em 0 0.075em !important;
        }

        .tiptap.ProseMirror h3,
        .tiptap .ProseMirror h3,
        .ProseMirror h3 {
          margin: 0.125em 0 0.063em !important;
        }

        /* ── Blockquote: reduce left indent ~75% ── */
        .tiptap blockquote {
          padding-left: 0.25rem !important;
        }

        /* ── Code blocks: reduce padding ~75% ── */
        .tiptap pre {
          padding: 0.2rem 0.25rem !important;
          margin: 0.125rem 0 !important;
        }

        .tiptap .code-block-wrapper,
        .ProseMirror .code-block-wrapper {
          margin: 0.125rem 0 !important;
        }

        .tiptap .code-block-wrapper pre,
        .ProseMirror .code-block-wrapper pre {
          padding: 0.25rem !important;
          padding-top: 2rem !important;
        }

        /* ── Collapsible sections: reduce content padding ~75% ── */
        .tiptap .collapsible-content,
        .ProseMirror .collapsible-content,
        [data-type="collapsible-content"] {
          padding: 0.125rem 0.25rem !important;
        }

        .tiptap .collapsible-section,
        .ProseMirror .collapsible-section,
        [data-type="collapsible"] {
          margin: 0.125rem 0 !important;
        }

        .tiptap .collapsible-title,
        .ProseMirror .collapsible-title,
        [data-type="collapsible-title"] {
          min-height: 1.6rem !important;
        }
      }

      .tiptap .ProseMirror:focus,
      .ProseMirror:focus {
        outline: none;
        box-shadow: none;
      }

      .flex.flex-col.w-full.rounded:focus-within {
        outline: none !important;
        box-shadow: none !important;
        border-color: #d1d5db !important;
      }

      .tiptap .ProseMirror ::selection,
      .tiptap .ProseMirror *::selection,
      .ProseMirror ::selection,
      .ProseMirror *::selection {
        background-color: rgba(59, 130, 246, 0.28);
        color: inherit;
        -webkit-text-fill-color: currentColor;
      }

      .tiptap .ProseMirror table,
      .ProseMirror table {
        border-collapse: collapse;
        border-spacing: 0;
        border: 1px solid #000000 !important;
      }

      .tiptap .tableWrapper,
      .ProseMirror .tableWrapper,
      .tableWrapper {
        display: block;
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        max-width: 100% !important;
        -webkit-overflow-scrolling: touch;
      }

      .tiptap .tableWrapper > table,
      .ProseMirror .tableWrapper > table,
      .tableWrapper > table {
        max-width: none !important;
      }

      .tiptap .ProseMirror th,
      .tiptap .ProseMirror td,
      .ProseMirror th,
      .ProseMirror td {
        border: 1px solid #000000 !important;
        position: relative;
        vertical-align: top;
        white-space: normal !important;
        word-break: break-word !important;
        overflow-wrap: anywhere !important;
      }

      .tiptap .ProseMirror th > p,
      .tiptap .ProseMirror td > p,
      .ProseMirror th > p,
      .ProseMirror td > p {
        margin: 0;
        min-height: 1.45em;
        white-space: normal !important;
        word-break: break-word !important;
        overflow-wrap: anywhere !important;
      }

      .tiptap .ProseMirror th > *,
      .tiptap .ProseMirror td > *,
      .ProseMirror th > *,
      .ProseMirror td > * {
        max-width: 100%;
      }

      .tiptap .ProseMirror th:focus-within,
      .tiptap .ProseMirror td:focus-within,
      .ProseMirror th:focus-within,
      .ProseMirror td:focus-within {
        box-shadow: inset 0 0 0 9999px rgba(59, 130, 246, 0.06);
      }

      .tiptap .ProseMirror .column-resize-handle,
      .tiptap .column-resize-handle {
        position: absolute;
        right: -4px;
        top: 0;
        bottom: 0;
        width: 8px;
        background: rgba(37, 99, 235, 0.45) !important;
        border-radius: 3px;
        pointer-events: auto;
        cursor: col-resize !important;
        z-index: 120;
      }

      .tiptap .column-resize-handle:hover {
        background: rgba(37, 99, 235, 0.75) !important;
        box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.95), 0 0 8px rgba(37, 99, 235, 0.8) !important;
      }

      .tiptap .ProseMirror .column-resize-handle:hover {
        cursor: col-resize !important;
      }

      .tiptap .ProseMirror[contenteditable="true"] .tableWrapper,
      .ProseMirror[contenteditable="true"] .tableWrapper {
        cursor: text;
      }

      .tiptap .ProseMirror[contenteditable="true"] .tableWrapper:hover,
      .ProseMirror[contenteditable="true"] .tableWrapper:hover {
        cursor: text;
      }

      .tiptap .ProseMirror[contenteditable="true"] .column-resize-handle,
      .ProseMirror[contenteditable="true"] .column-resize-handle,
      .tiptap .ProseMirror[contenteditable="true"] .column-resize-handle:hover,
      .ProseMirror[contenteditable="true"] .column-resize-handle:hover,
      .tiptap.table-resize-candidate,
      .tiptap.table-resize-candidate *,
      .tiptap .ProseMirror.resize-cursor,
      .ProseMirror.resize-cursor,
      body.resize-cursor,
      body.table-resize-candidate {
        cursor: col-resize !important;
      }

      .tiptap .ProseMirror[contenteditable="true"] th.table-resize-candidate-cell,
      .tiptap .ProseMirror[contenteditable="true"] td.table-resize-candidate-cell,
      .ProseMirror[contenteditable="true"] th.table-resize-candidate-cell,
      .ProseMirror[contenteditable="true"] td.table-resize-candidate-cell {
        box-shadow: inset 0 0 0 9999px rgba(59, 130, 246, 0.18) !important;
        outline: 1px solid rgba(59, 130, 246, 0.65) !important;
        outline-offset: -1px;
        overflow: visible !important;
      }

      .tiptap .ProseMirror[contenteditable="true"] th.table-resize-dragging-cell,
      .tiptap .ProseMirror[contenteditable="true"] td.table-resize-dragging-cell,
      .ProseMirror[contenteditable="true"] th.table-resize-dragging-cell,
      .ProseMirror[contenteditable="true"] td.table-resize-dragging-cell {
        box-shadow: inset 0 0 0 9999px rgba(37, 99, 235, 0.26) !important;
        outline: 2px solid rgba(37, 99, 235, 0.95) !important;
      }

      .tiptap .ProseMirror[contenteditable="true"] th.table-resize-candidate-cell,
      .tiptap .ProseMirror[contenteditable="true"] td.table-resize-candidate-cell,
      .ProseMirror[contenteditable="true"] th.table-resize-candidate-cell,
      .ProseMirror[contenteditable="true"] td.table-resize-candidate-cell {
        position: relative;
      }

      .tiptap .ProseMirror[contenteditable="true"] th.table-resize-edge-right::after,
      .tiptap .ProseMirror[contenteditable="true"] td.table-resize-edge-right::after,
      .ProseMirror[contenteditable="true"] th.table-resize-edge-right::after,
      .ProseMirror[contenteditable="true"] td.table-resize-edge-right::after {
        content: '';
        position: absolute;
        top: -1px;
        right: -3px;
        width: 6px;
        height: calc(100% + 2px);
        background: rgba(37, 99, 235, 0.95) !important;
        border-radius: 2px;
        box-shadow:
          0 0 0 2px rgba(255, 255, 255, 0.95),
          0 0 0 3px rgba(37, 99, 235, 0.7),
          0 0 14px rgba(37, 99, 235, 0.9) !important;
        pointer-events: none;
        z-index: 999;
      }

      .tiptap .ProseMirror[contenteditable="true"] th.table-resize-edge-left::before,
      .tiptap .ProseMirror[contenteditable="true"] td.table-resize-edge-left::before,
      .ProseMirror[contenteditable="true"] th.table-resize-edge-left::before,
      .ProseMirror[contenteditable="true"] td.table-resize-edge-left::before {
        content: '';
        position: absolute;
        top: -1px;
        left: -3px;
        width: 6px;
        height: calc(100% + 2px);
        background: rgba(37, 99, 235, 0.95) !important;
        border-radius: 2px;
        box-shadow:
          0 0 0 2px rgba(255, 255, 255, 0.95),
          0 0 0 3px rgba(37, 99, 235, 0.7),
          0 0 14px rgba(37, 99, 235, 0.9) !important;
        pointer-events: none;
        z-index: 999;
      }

      .table-resize-hover-indicator {
        position: fixed;
        width: 8px;
        opacity: 0;
        pointer-events: none;
        z-index: 2147483647;
        border-radius: 3px;
        transition: opacity 80ms ease;
      }

      .table-resize-hover-indicator.visible {
        opacity: 1;
        background: rgba(37, 99, 235, 0.98);
        box-shadow:
          0 0 0 2px rgba(255, 255, 255, 0.98),
          0 0 0 4px rgba(37, 99, 235, 0.7),
          0 0 16px rgba(37, 99, 235, 0.95),
          0 0 30px rgba(37, 99, 235, 0.6);
      }

      .table-resize-hover-indicator.visible.dragging {
        background: rgba(29, 78, 216, 1);
        box-shadow:
          0 0 0 2px rgba(255, 255, 255, 1),
          0 0 0 5px rgba(29, 78, 216, 0.9),
          0 0 18px rgba(29, 78, 216, 1),
          0 0 38px rgba(29, 78, 216, 0.85),
          0 0 56px rgba(29, 78, 216, 0.55);
      }

      .tiptap .ProseMirror[contenteditable="false"] .tableWrapper,
      .ProseMirror[contenteditable="false"] .tableWrapper {
        overflow-x: auto !important;
        overflow-y: hidden !important;
        max-width: 100% !important;
        -webkit-overflow-scrolling: touch;
      }

      .tiptap .ProseMirror[contenteditable="false"] table,
      .ProseMirror[contenteditable="false"] table {
        max-width: none !important;
      }

      .tiptap .ProseMirror[contenteditable="false"] th,
      .tiptap .ProseMirror[contenteditable="false"] td,
      .ProseMirror[contenteditable="false"] th,
      .ProseMirror[contenteditable="false"] td {
        white-space: normal !important;
        word-break: break-word !important;
        overflow-wrap: anywhere !important;
      }

      /* Code block styling for ChatGPT paste */
      .tiptap pre {
        background: #f5f5f5;
        color: #1f2937;
        font-family: 'Courier New', Courier, monospace;
        padding: 0.75rem 1rem;
        border-radius: 0.5rem;
        border: 1px solid #e5e7eb;
        overflow-x: auto;
        margin: 0.5rem 0;
      }

      .tiptap pre code {
        background: none;
        color: inherit;
        font-size: 0.9em;
        padding: 0;
      }

      .tiptap code {
        background-color: #f3f4f6;
        color: #1f2937;
        padding: 0.2em 0.4em;
        border-radius: 0.25rem;
        font-family: 'Courier New', Courier, monospace;
        font-size: 0.9em;
      }

      /* Code block with copy button wrapper */
      .tiptap .code-block-wrapper,
      .ProseMirror .code-block-wrapper {
        position: relative !important;
        margin: 0.5rem 0 !important;
      }

      .tiptap .code-block-wrapper pre,
      .ProseMirror .code-block-wrapper pre {
        margin: 0 !important;
        padding: 1rem !important;
        padding-top: 2.5rem !important;
        background-color: #1e293b !important;
        color: #e2e8f0 !important;
        border-radius: 0.375rem !important;
        overflow-x: auto !important;
        font-family: 'Courier New', Courier, monospace !important;
        font-size: 0.875rem !important;
        line-height: 1.5 !important;
        border: 1px solid #334155 !important;
      }

      .tiptap .code-block-wrapper pre code,
      .ProseMirror .code-block-wrapper pre code {
        background: none !important;
        color: inherit !important;
        padding: 0 !important;
        border-radius: 0 !important;
      }

      .code-block-copy-btn {
        position: absolute !important;
        top: 0.5rem !important;
        right: 0.5rem !important;
        padding: 0.375rem 0.5rem !important;
        background-color: rgba(255, 255, 255, 0.1) !important;
        border: 1px solid rgba(255, 255, 255, 0.2) !important;
        border-radius: 0.25rem !important;
        color: #e2e8f0 !important;
        cursor: pointer !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        transition: all 0.2s !important;
        z-index: 10 !important;
        font-family: inherit !important;
      }

      .code-block-copy-btn:hover {
        background-color: rgba(255, 255, 255, 0.2) !important;
        border-color: rgba(255, 255, 255, 0.3) !important;
        transform: scale(1.05) !important;
      }

      .code-block-copy-btn:active {
        transform: scale(0.95) !important;
      }


      .tiptap blockquote {
        border-left: 3px solid #d1d5db;
        padding-left: 1rem;
        margin-left: 0;
        font-style: italic;
        color: #6b7280;
      }

      /* Collapsible section styling */
      .tiptap .collapsible-section,
      .ProseMirror .collapsible-section,
      [data-type="collapsible"] {
        border: 2px solid var(--primary-color, var(--p-primary-color, #3b82f6)) !important;
        border-radius: 0.375rem !important;
        margin: 0.5rem 0 !important;
        overflow: visible !important;
        display: block !important;
        background-color: #f3f4f6 !important;
        padding: 0 !important;
      }

      /* Force styling regardless of editable state */
      .tiptap.ProseMirror-focused .collapsible-section,
      .tiptap.ProseMirror-focused [data-type="collapsible"],
      .ProseMirror-focused .collapsible-section,
      .ProseMirror-focused [data-type="collapsible"] {
        border: 2px solid var(--primary-color, var(--p-primary-color, #3b82f6)) !important;
        background-color: #f3f4f6 !important;
        box-shadow: 0 2px 4px color-mix(in srgb, var(--primary-color, var(--p-primary-color, #3b82f6)) 15%, transparent) !important;
      }

      .collapsible-wrapper {
        display: flex !important;
        flex-direction: column !important;
      }

      .tiptap .collapsible-title,
      .ProseMirror .collapsible-title,
      [data-type="collapsible-title"] {
        background-color: rgba(59, 130, 246, 0.32) !important;
        background-color: color-mix(in srgb, var(--primary-color, var(--p-primary-color, #3b82f6)) 28%, white) !important;
        color: #0f172a !important;
        font-weight: 600 !important;
        transition: background-color 200ms !important;
        display: flex !important;
        align-items: flex-start !important;
        min-height: 2.25rem !important;
        position: relative !important;
      }

      /* Icon wrapper only gets pointer cursor and no-select, not the entire content area */
      .tiptap .collapsible-title [contenteditable="false"],
      .ProseMirror .collapsible-title [contenteditable="false"],
      [data-type="collapsible-title"] [contenteditable="false"] {
        cursor: pointer !important;
        user-select: none !important;
      }

      .tiptap .collapsible-title:hover,
      .ProseMirror .collapsible-title:hover,
      [data-type="collapsible-title"]:hover {
        background-color: rgba(59, 130, 246, 0.4) !important;
        background-color: color-mix(in srgb, var(--primary-color, var(--p-primary-color, #3b82f6)) 38%, white) !important;
      }

      .tiptap .collapsible-icon,
      .ProseMirror .collapsible-icon,
      .collapsible-icon {
        transition: transform 200ms !important;
        cursor: pointer !important;
      }

      .tiptap .collapsible-content,
      .ProseMirror .collapsible-content,
      [data-type="collapsible-content"] {
        padding: 0.5rem 1rem !important;
        transition: opacity 200ms ease-in-out, padding 200ms ease-in-out !important;
        overflow: hidden !important;
        background-color: #ffffff !important;
        max-height: none !important;
        height: auto !important;
        contain: layout style !important;
      }

      /* Read-only mode - lighter styling */
      .tiptap[contenteditable="false"] .collapsible-section,
      .ProseMirror[contenteditable="false"] .collapsible-section,
      .tiptap[contenteditable="false"] [data-type="collapsible"],
      .ProseMirror[contenteditable="false"] [data-type="collapsible"] {
        border: 1px solid #e5e7eb !important;
        background-color: transparent !important;
        box-shadow: none !important;
      }

      .tiptap[contenteditable="false"] .collapsible-title,
      .ProseMirror[contenteditable="false"] .collapsible-title,
      .tiptap[contenteditable="false"] [data-type="collapsible-title"],
      .ProseMirror[contenteditable="false"] [data-type="collapsible-title"] {
        background-color: color-mix(in srgb, var(--primary-color, var(--p-primary-color, #3b82f6)) 14%, white) !important;
        color: #0f172a !important;
      }

      /* Collapsible section actions menu button */
      .collapsible-menu-btn {
        position: absolute !important;
        top: 0.3rem !important;
        right: 0.5rem !important;
        width: 1.9rem !important;
        height: 1.9rem !important;
        padding: 0 !important;
        background-color: #f3f4f6 !important;
        border: 1px solid #d1d5db !important;
        border-radius: 0.375rem !important;
        color: #6b7280 !important;
        cursor: pointer !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        transition: all 0.2s !important;
        z-index: 10 !important;
        font-family: inherit !important;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08) !important;
      }

      .collapsible-menu-btn:hover {
        background-color: #e5e7eb !important;
        border-color: #9ca3af !important;
        color: #4b5563 !important;
        box-shadow: 0 2px 6px rgba(15, 23, 42, 0.12) !important;
        transform: scale(1.05) !important;
      }

      .collapsible-menu-btn:active {
        transform: scale(0.95) !important;
      }

      .collapsible-section-menu-panel {
        position: fixed;
        min-width: 12rem;
        background: #ffffff;
        border: 1px solid #d1d5db;
        border-radius: 0.5rem;
        box-shadow: 0 18px 48px rgba(15, 23, 42, 0.22), 0 6px 18px rgba(15, 23, 42, 0.14);
        z-index: 2147483647;
        overflow: hidden;
      }

      .collapsible-section-menu-item {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        width: 100%;
        padding: 0.75rem 0.875rem;
        border: 0;
        background: transparent;
        color: #111827;
        font-size: 0.875rem;
        text-align: left;
        cursor: pointer;
      }

      .collapsible-section-menu-item:hover {
        background: #f3f4f6;
      }

      .collapsible-section-menu-item.delete-action {
        color: #b91c1c;
      }

      /* Make collapsible sections clearly selectable and deletable */
      .ProseMirror-selectednode.collapsible-section,
      .collapsible-section.ProseMirror-selectednode {
        outline: 2px solid var(--primary-color, var(--p-primary-color, #3b82f6)) !important;
        outline-offset: 2px;
      }

      /* Gap cursor for easy navigation */
      .ProseMirror-gapcursor {
        display: block;
        pointer-events: none;
        position: relative;
      }

      .ProseMirror-gapcursor:after {
        content: '';
        display: block;
        position: absolute;
        top: -2px;
        width: 20px;
        border-top: 1px solid var(--primary-color, var(--p-primary-color, #3b82f6));
        animation: blink-gap 1.2s step-end infinite;
      }

      @keyframes blink-gap {
        0%, 50% { opacity: 1; }
        51%, 100% { opacity: 0; }
      }

      /* Sticky toolbar - sticks to top of viewport when scrolling */
      .editor-toolbar-sticky {
        position: sticky;
        top: var(--edit-appbar-height, 3.25rem);
        z-index: 900;
        background: var(--toolbarBackgroundColor, #f8fafc);
      }

      .mobile-editor-toolbar-grid {
        display: flex;
        flex-wrap: nowrap;
        gap: 0.5rem;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 0.1rem;
      }

      .mobile-editor-toolbar-section {
        flex: 0 0 auto;
        min-width: max-content;
        border: 1px solid #dbe3ee;
        border-radius: 0.75rem;
        padding: 0.5rem;
        background: #ffffff;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
      }

      .mobile-editor-toolbar-section--wide {
        min-width: max-content;
      }

      .mobile-editor-toolbar-section__title {
        font-size: 0.7rem;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        color: #64748b;
        margin-bottom: 0.4rem;
      }

      .mobile-editor-toolbar-actions {
        display: flex;
        flex-wrap: wrap;
        gap: 0.35rem;
        align-items: center;
      }

      .mobile-editor-toolbar-actions--stretch {
        flex-wrap: nowrap;
        min-width: max-content;
      }

      .mobile-toolbar-btn {
        min-width: 2.25rem;
        min-height: 2.25rem;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.6rem;
        border: 1px solid #cbd5e1;
        background: #ffffff;
        color: #1f2937;
        flex: 0 0 auto;
      }

      .mobile-toolbar-btn:disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }

      .mobile-toolbar-select {
        width: auto;
        min-width: 0;
        min-height: 2.25rem;
        border-radius: 0.6rem;
        border: 1px solid #cbd5e1;
        background: #ffffff;
        padding: 0 0.65rem;
        color: #1f2937;
      }

      .mobile-editor-toolbar-actions--stretch .mobile-toolbar-btn,
      .mobile-editor-toolbar-actions--stretch .mobile-toolbar-select,
      .mobile-editor-toolbar-actions--stretch app-color-swatch-picker {
        flex: 0 0 auto;
        min-width: 0;
      }

      @media (max-width: 639px) {
        .mobile-editor-toolbar-grid {
          flex-wrap: nowrap;
        }

        .mobile-editor-toolbar-actions--stretch app-color-swatch-picker {
          min-width: 0;
        }
      }

      @media (max-width: 430px) {
        .mobile-editor-toolbar-section {
          padding: 0.45rem;
        }
      }

      /* Toolbar buttons use primary color (90% dark) */
      .editor-toolbar-sticky button,
      .editor-toolbar-sticky select,
      .editor-toolbar-sticky .p-button,
      .editor-toolbar-sticky .p-button .p-button-icon {
        color: var(--toolbar-icon-color, #1f2937) !important;
      }

      .editor-toolbar-sticky button span,
      .editor-toolbar-sticky .material-icons,
      .editor-toolbar-sticky .material-symbols-outlined {
        color: var(--toolbar-icon-color, #1f2937) !important;
      }

      .editor-toolbar-sticky .toolbar-button-active {
        background-color: rgba(37, 99, 235, 0.14) !important;
        border-color: rgba(37, 99, 235, 0.42) !important;
        box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.2);
      }

      .editor-toolbar-sticky .style-transfer-sticky {
        background-color: rgba(220, 38, 38, 0.14) !important;
        border-color: rgba(220, 38, 38, 0.45) !important;
        box-shadow: inset 0 0 0 1px rgba(220, 38, 38, 0.28);
        color: #b91c1c !important;
      }

      .editor-toolbar-sticky .style-transfer-sticky span,
      .editor-toolbar-sticky .style-transfer-sticky .material-icons {
        color: #b91c1c !important;
      }

      .tiptap.style-transfer-cursor-active,
      .tiptap.style-transfer-cursor-active .ProseMirror,
      .tiptap.style-transfer-cursor-active .ProseMirror * {
        cursor: copy !important;
      }

      /* Structural paragraph indentation (data-indent attribute, set via the
         ParagraphIndent extension). The inline margin-left style set by the
         extension's renderHTML already covers the editor itself; these
         rules are a fallback for HTML rendered without that inline style
         (e.g. hand-edited). Keep the em-per-level value in sync with
         PARAGRAPH_INDENT_EM_PER_LEVEL in extensions/paragraph-indent.ts. */
      .tiptap p[data-indent="1"] { margin-left: 2em; }
      .tiptap p[data-indent="2"] { margin-left: 4em; }
      .tiptap p[data-indent="3"] { margin-left: 6em; }
      .tiptap p[data-indent="4"] { margin-left: 8em; }
      .tiptap p[data-indent="5"] { margin-left: 10em; }
      .tiptap p[data-indent="6"] { margin-left: 12em; }
      .tiptap p[data-indent="7"] { margin-left: 14em; }
      .tiptap p[data-indent="8"] { margin-left: 16em; }

      /* Task List Styles - Remove bullet points and format properly */
      /* Target all possible variations: data attributes AND class names */
      ul[data-type="taskList"],
      ul.task-list,
      .tiptap ul[data-type="taskList"],
      .tiptap ul.task-list,
      .tiptap .ProseMirror ul[data-type="taskList"],
      .tiptap .ProseMirror ul.task-list,
      .ProseMirror ul[data-type="taskList"],
      .ProseMirror ul.task-list {
        list-style: none !important;
        list-style-type: none !important;
        padding-left: 0 !important;
        margin-left: 0 !important;
      }

      /* Task list items - MUST use flexbox for same-line layout */
      ul[data-type="taskList"] > li,
      ul.task-list > li,
      li[data-type="taskItem"],
      li.task-item,
      .tiptap ul[data-type="taskList"] > li,
      .tiptap ul.task-list > li,
      .tiptap li[data-type="taskItem"],
      .tiptap li.task-item,
      .tiptap .ProseMirror ul[data-type="taskList"] > li,
      .tiptap .ProseMirror ul.task-list > li,
      .tiptap .ProseMirror li[data-type="taskItem"],
      .tiptap .ProseMirror li.task-item,
      .ProseMirror ul[data-type="taskList"] > li,
      .ProseMirror ul.task-list > li,
      .ProseMirror li[data-type="taskItem"],
      .ProseMirror li.task-item {
        display: flex !important;
        flex-direction: row !important;
        align-items: flex-start !important;
        gap: 0.5rem !important;
        margin: 0.25rem 0 !important;
        padding-left: 0 !important;
        list-style: none !important;
        list-style-type: none !important;
      }

      /* Remove any ::before or ::marker pseudo-elements */
      ul[data-type="taskList"] > li::before,
      ul.task-list > li::before,
      li[data-type="taskItem"]::before,
      li.task-item::before,
      ul[data-type="taskList"] > li::marker,
      ul.task-list > li::marker,
      li[data-type="taskItem"]::marker,
      li.task-item::marker,
      .tiptap ul[data-type="taskList"] > li::before,
      .tiptap ul.task-list > li::before,
      .tiptap li[data-type="taskItem"]::before,
      .tiptap li.task-item::before,
      .tiptap ul[data-type="taskList"] > li::marker,
      .tiptap ul.task-list > li::marker,
      .tiptap li[data-type="taskItem"]::marker,
      .tiptap li.task-item::marker,
      .ProseMirror ul[data-type="taskList"] > li::before,
      .ProseMirror ul.task-list > li::before,
      .ProseMirror li[data-type="taskItem"]::before,
      .ProseMirror li.task-item::before,
      .ProseMirror ul[data-type="taskList"] > li::marker,
      .ProseMirror ul.task-list > li::marker,
      .ProseMirror li[data-type="taskItem"]::marker,
      .ProseMirror li.task-item::marker {
        display: none !important;
        content: none !important;
      }

      /* Label containing checkbox */
      ul[data-type="taskList"] > li > label,
      ul.task-list > li > label,
      li[data-type="taskItem"] > label,
      li.task-item > label,
      .tiptap ul[data-type="taskList"] > li > label,
      .tiptap ul.task-list > li > label,
      .tiptap li[data-type="taskItem"] > label,
      .tiptap li.task-item > label,
      .ProseMirror ul[data-type="taskList"] > li > label,
      .ProseMirror ul.task-list > li > label,
      .ProseMirror li[data-type="taskItem"] > label,
      .ProseMirror li.task-item > label {
        flex: 0 0 auto !important;
        margin: 0 !important;
        padding: 0 !important;
        user-select: none !important;
        display: block !important;
      }

      /* Content div - should be on same line as checkbox */
      ul[data-type="taskList"] > li > div,
      ul.task-list > li > div,
      li[data-type="taskItem"] > div,
      li.task-item > div,
      .tiptap ul[data-type="taskList"] > li > div,
      .tiptap ul.task-list > li > div,
      .tiptap li[data-type="taskItem"] > div,
      .tiptap li.task-item > div,
      .ProseMirror ul[data-type="taskList"] > li > div,
      .ProseMirror ul.task-list > li > div,
      .ProseMirror li[data-type="taskItem"] > div,
      .ProseMirror li.task-item > div {
        flex: 1 1 auto !important;
        min-width: 0 !important;
        margin: 0 !important;
      }

      /* Checkbox input */
      ul[data-type="taskList"] > li input[type="checkbox"],
      ul.task-list > li input[type="checkbox"],
      li[data-type="taskItem"] input[type="checkbox"],
      li.task-item input[type="checkbox"],
      .tiptap ul[data-type="taskList"] > li input[type="checkbox"],
      .tiptap ul.task-list > li input[type="checkbox"],
      .tiptap li[data-type="taskItem"] input[type="checkbox"],
      .tiptap li.task-item input[type="checkbox"],
      .ProseMirror ul[data-type="taskList"] > li input[type="checkbox"],
      .ProseMirror ul.task-list > li input[type="checkbox"],
      .ProseMirror li[data-type="taskItem"] input[type="checkbox"],
      .ProseMirror li.task-item input[type="checkbox"] {
        cursor: pointer !important;
        width: 1rem !important;
        height: 1rem !important;
        margin: 0 !important;
        padding: 0 !important;
        flex-shrink: 0 !important;
      }

      /* Checked task item - grey, italic, strikethrough */
      ul[data-type="taskList"] > li[data-checked="true"] > div,
      ul[data-type="taskList"] > li[data-checked="true"] > div > p,
      ul[data-type="taskList"] > li[data-checked="true"] > div *,
      ul.task-list > li[data-checked="true"] > div,
      ul.task-list > li[data-checked="true"] > div > p,
      ul.task-list > li[data-checked="true"] > div *,
      li[data-type="taskItem"][data-checked="true"] > div,
      li[data-type="taskItem"][data-checked="true"] > div > p,
      li[data-type="taskItem"][data-checked="true"] > div *,
      li.task-item[data-checked="true"] > div,
      li.task-item[data-checked="true"] > div > p,
      li.task-item[data-checked="true"] > div *,
      .tiptap ul[data-type="taskList"] > li[data-checked="true"] > div,
      .tiptap ul[data-type="taskList"] > li[data-checked="true"] > div > p,
      .tiptap ul[data-type="taskList"] > li[data-checked="true"] > div *,
      .tiptap ul.task-list > li[data-checked="true"] > div,
      .tiptap ul.task-list > li[data-checked="true"] > div > p,
      .tiptap ul.task-list > li[data-checked="true"] > div *,
      .tiptap li[data-type="taskItem"][data-checked="true"] > div,
      .tiptap li[data-type="taskItem"][data-checked="true"] > div > p,
      .tiptap li[data-type="taskItem"][data-checked="true"] > div *,
      .tiptap li.task-item[data-checked="true"] > div,
      .tiptap li.task-item[data-checked="true"] > div > p,
      .tiptap li.task-item[data-checked="true"] > div *,
      .ProseMirror ul[data-type="taskList"] > li[data-checked="true"] > div,
      .ProseMirror ul[data-type="taskList"] > li[data-checked="true"] > div > p,
      .ProseMirror ul[data-type="taskList"] > li[data-checked="true"] > div *,
      .ProseMirror ul.task-list > li[data-checked="true"] > div,
      .ProseMirror ul.task-list > li[data-checked="true"] > div > p,
      .ProseMirror ul.task-list > li[data-checked="true"] > div *,
      .ProseMirror li[data-type="taskItem"][data-checked="true"] > div,
      .ProseMirror li[data-type="taskItem"][data-checked="true"] > div > p,
      .ProseMirror li[data-type="taskItem"][data-checked="true"] > div *,
      .ProseMirror li.task-item[data-checked="true"] > div,
      .ProseMirror li.task-item[data-checked="true"] > div > p,
      .ProseMirror li.task-item[data-checked="true"] > div * {
        color: #9ca3af !important;
        font-style: italic !important;
        text-decoration: line-through !important;
      }

      @media screen {
        .dark .flex.flex-col.w-full.max-w-full.rounded {
          background: #0f172a !important;
          border-color: #334155 !important;
        }

        .p-dark .flex.flex-col.w-full.max-w-full.rounded {
          background: #0f172a !important;
          border-color: #334155 !important;
        }

        .p-dark .editor-toolbar-sticky {
          background: #111827 !important;
          border-color: #334155 !important;
        }

        .p-dark .editor-toolbar-sticky button,
        .p-dark .editor-toolbar-sticky select,
        .p-dark .editor-toolbar-sticky .p-button,
        .p-dark .editor-toolbar-sticky .mobile-toolbar-btn,
        .p-dark .editor-toolbar-sticky .mobile-toolbar-select {
          background: #1f2937 !important;
          border-color: #475569 !important;
          color: #e2e8f0 !important;
        }

        .p-dark .editor-toolbar-sticky .mobile-editor-toolbar-section {
          background: #0f172a !important;
          border-color: #334155 !important;
        }

        .dark .tiptap,
        .dark .tiptap .ProseMirror,
        .dark .ProseMirror,
        .p-dark .tiptap,
        .p-dark .tiptap .ProseMirror,
        .p-dark .ProseMirror {
          background-color: #111827 !important;
          color: #e2e8f0 !important;
          caret-color: #f8fafc;
        }

        .p-dark .tiptap .collapsible-content,
        .p-dark .ProseMirror .collapsible-content,
        .p-dark [data-type="collapsible-content"] {
          background-color: #111827 !important;
          color: #e2e8f0 !important;
        }

        .dark .tiptap .collapsible-section,
        .dark .ProseMirror .collapsible-section,
        .dark [data-type="collapsible"] {
          background-color: #1f2937 !important;
          border-color: color-mix(in srgb, var(--primary-color, var(--p-primary-color, #3b82f6)) 50%, #111827) !important;
        }

        .dark .tiptap .collapsible-content,
        .dark .ProseMirror .collapsible-content,
        .dark [data-type="collapsible-content"] {
          background-color: #111827 !important;
          color: #e2e8f0 !important;
        }

        .dark .tiptap .collapsible-title,
        .dark .ProseMirror .collapsible-title,
        .dark [data-type="collapsible-title"] {
          color: #e2e8f0 !important;
          background-color: color-mix(in srgb, var(--primary-color, var(--p-primary-color, #3b82f6)) 32%, #111827) !important;
        }

        .p-dark .tiptap[contenteditable="false"] .collapsible-title,
        .p-dark .ProseMirror[contenteditable="false"] .collapsible-title,
        .p-dark .tiptap[contenteditable="false"] [data-type="collapsible-title"],
        .p-dark .ProseMirror[contenteditable="false"] [data-type="collapsible-title"] {
          background-color: color-mix(in srgb, var(--primary-color, var(--p-primary-color, #3b82f6)) 24%, #0f172a) !important;
          color: #e2e8f0 !important;
        }

        .p-dark .tiptap[contenteditable="false"] .collapsible-title *,
        .p-dark .ProseMirror[contenteditable="false"] .collapsible-title *,
        .p-dark .tiptap[contenteditable="false"] [data-type="collapsible-title"] *,
        .p-dark .ProseMirror[contenteditable="false"] [data-type="collapsible-title"] * {
          color: #e2e8f0 !important;
        }

        .p-dark .tiptap blockquote,
        .p-dark .ProseMirror blockquote {
          border-left-color: #475569;
          color: #cbd5e1;
        }

        .p-dark .collapsible-menu-btn,
        .p-dark .image-node-menu-trigger {
          background-color: #1f2937 !important;
          border-color: #475569 !important;
          color: #e2e8f0 !important;
        }

        .p-dark .collapsible-menu-btn:hover,
        .p-dark .image-node-menu-trigger:hover {
          background-color: #334155 !important;
          border-color: #64748b !important;
        }

        .p-dark .collapsible-section-menu-panel,
        .p-dark .image-node-menu-panel {
          background: #111827;
          border-color: #334155;
        }

        .p-dark .collapsible-section-menu-item,
        .p-dark .image-node-menu-item {
          color: #e2e8f0;
        }

        .p-dark .collapsible-section-menu-item:hover,
        .p-dark .image-node-menu-item:hover {
          background: #1f2937;
        }

        .p-dark .editor-toolbar-sticky .absolute.z-20.mt-2.w-56.rounded.border.bg-white.shadow {
          background: #111827 !important;
          border-color: #334155 !important;
          color: #e2e8f0 !important;
        }

        .p-dark .editor-toolbar-sticky .absolute.z-20.mt-2.w-56.rounded.border.bg-white.shadow button,
        .p-dark .editor-toolbar-sticky .absolute.z-20.mt-2.w-56.rounded.border.bg-white.shadow div {
          color: #e2e8f0 !important;
        }

        .p-dark .editor-toolbar-sticky .absolute.z-20.mt-2.w-56.rounded.border.bg-white.shadow button:hover {
          background: #1f2937 !important;
        }
      }
    </style>


    <div class="flex flex-col w-full max-w-full rounded bg-surface-0 dark:bg-surface-900 border border-surface-300 dark:border-surface-700 overflow-visible"
      [class.flex-1]="fillHeight"
      [class.min-h-0]="fillHeight"
      style="box-shadow: none !important;">

      <!-- TOOLBAR -->
      <div *ngIf="!readOnly"
           class="editor-toolbar-sticky flex flex-nowrap sm:flex-wrap items-center gap-1 border-b p-2 bg-surface-50 overflow-x-auto sm:overflow-x-visible"
           [style.--toolbar-icon-color]="getToolbarButtonStyle().color"
           [style.--primary-color]="getPrimaryColor()">

        <!-- UNDO / REDO -->
        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed"
          [disabled]="!canUndo"
          (mousedown)="$event.preventDefault()"
          (click)="undo()"
          pTooltip="Undo"
          tooltipPosition="bottom">
          <span class="material-icons text-base">undo</span>
        </button>

        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed"
          [disabled]="!canRedo"
          (mousedown)="$event.preventDefault()"
          (click)="redo()"
          pTooltip="Redo"
          tooltipPosition="bottom">
          <span class="material-icons text-base">redo</span>
        </button>

        <!-- TEXT STYLES -->
        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center font-bold"
          [ngClass]="[btn(isBoldActive), isBoldActive ? 'toolbar-button-active' : '']"
          (mousedown)="$event.preventDefault()"
          (click)="toggleBold()"
          pTooltip="Bold"
          tooltipPosition="bottom">
          B
        </button>

        <button class="px-2 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center italic"
          [ngClass]="[btn(isItalicActive), isItalicActive ? 'toolbar-button-active' : '']"
          (mousedown)="$event.preventDefault()"
          (click)="toggleItalic()"
          pTooltip="Italic"
          tooltipPosition="bottom">
          I
        </button>

        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center underline"
          [ngClass]="[btn(isUnderlineActive), isUnderlineActive ? 'toolbar-button-active' : '']"
          (mousedown)="$event.preventDefault()"
          (click)="toggleUnderline()"
          pTooltip="Underline"
          tooltipPosition="bottom">
          U
        </button>

        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center line-through"
          [ngClass]="[btn(isStrikeActive), isStrikeActive ? 'toolbar-button-active' : '']"
          (mousedown)="$event.preventDefault()"
          (click)="toggleStrike()"
          pTooltip="Strike-through"
          tooltipPosition="bottom">
          S
        </button>

        <!-- LISTS -->
        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
          [ngClass]="[btn(isBulletListActive), isBulletListActive ? 'toolbar-button-active' : '']"
          (mousedown)="$event.preventDefault()"
          (click)="toggleBulletList()"
          pTooltip="Bullet list"
          tooltipPosition="bottom">
          <span class="material-icons text-base">format_list_bulleted</span>
        </button>

        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
          [ngClass]="[btn(isTaskListToolbarActive), isTaskListToolbarActive ? 'toolbar-button-active' : '']"
          (mousedown)="$event.preventDefault()"
          (click)="toggleChecklist()"
          pTooltip="Task list"
          tooltipPosition="bottom">
          <span class="material-icons text-base">check_box</span>
        </button>

        <!-- INLINE TASK (owner + due date) -->
        <button type="button"
          class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
          data-testid="toolbar-add-task"
          aria-label="Add task"
          (mousedown)="$event.preventDefault()"
          (click)="insertTask()"
          pTooltip="Add task (Ctrl/⌘+Alt+N, or type /task). In a task: @ owner · /due due date · Ctrl/⌘+Enter done · Ctrl/⌘+Shift+Backspace delete"
          tooltipPosition="bottom">
          <span class="material-icons text-base">add_task</span>
        </button>

        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
          [ngClass]="[btn(isOrderedListActive), isOrderedListActive ? 'toolbar-button-active' : '']"
          (mousedown)="$event.preventDefault()"
          (click)="toggleOrderedList()"
          pTooltip="Numbered list / continue numbering"
          tooltipPosition="bottom">
          <span class="material-icons text-base">format_list_numbered</span>
        </button>

        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
          [ngClass]="[btn(isRestartOrderedListActive), isRestartOrderedListActive ? 'toolbar-button-active' : '']"
          (mousedown)="$event.preventDefault()"
          (click)="restartOrderedList()"
          pTooltip="Restart numbering at 1"
          tooltipPosition="bottom">
          <span class="material-icons text-base">restart_alt</span>
        </button>
        <!-- TEXT COLOR -->
        <app-color-swatch-picker
          [value]="currentTextColor"
          [active]="!!currentTextColor"
          mode="text"
          [allowClear]="true"
          [showRecent]="true"
          [showAdvanced]="true"
          (colorSelected)="onTextColorSelected($event)">
        </app-color-swatch-picker>

        <!-- BACKGROUND COLOR -->
        <app-color-swatch-picker
          [value]="currentBackgroundColor"
          [active]="!!currentBackgroundColor"
          mode="background"
          [allowClear]="true"
          [showRecent]="true"
          [showAdvanced]="true"
          (colorSelected)="onBackgroundColorSelected($event)">
        </app-color-swatch-picker>

        <!-- STYLE TRANSFER (Copy / Paste style) -->
        <button
          class="style-transfer-toggle px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
          [ngClass]="[
            btn(styleTransferMode === 'paste'),
            styleTransferMode === 'paste' ? 'toolbar-button-active' : '',
            isStyleTransferSticky ? 'style-transfer-sticky' : ''
          ]"
          (mousedown)="$event.preventDefault()"
          (click)="onStyleTransferButtonClick($event)"
          (dblclick)="onStyleTransferButtonDoubleClick($event)"
          [pTooltip]="getStyleTransferTitle()"
          tooltipPosition="bottom">
          <span class="material-icons text-base">{{ getStyleTransferIcon() }}</span>
        </button>

        <!-- CODE BLOCK -->
        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
          [ngClass]="btn(editor?.isActive('codeBlock'))"
          (mousedown)="$event.preventDefault()"
          (click)="toggleCodeBlock()"
          pTooltip="Code block"
          tooltipPosition="bottom">
          <span class="material-icons text-base">code</span>
        </button>

        <!-- COLLAPSIBLE SECTION -->
        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
          [ngClass]="btn(editor?.isActive('collapsibleSection'))"
          (mousedown)="$event.preventDefault()"
          (click)="insertCollapsibleSection()"
          pTooltip="Insert collapsible section"
          tooltipPosition="bottom">
          <span class="material-icons text-base">expand_more</span>
        </button>

        <!-- CONVERT MARKDOWN -->
        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
          (mousedown)="$event.preventDefault()"
          (click)="convertSelectionMarkdown()"
          pTooltip="Convert selected markdown to rich text"
          tooltipPosition="bottom">
          <span class="material-icons text-base">auto_fix_high</span>
        </button>

        <!-- INDENTATION -->
        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
          (mousedown)="$event.preventDefault()"
          (click)="increaseIndent()"
          pTooltip="Increase indentation"
          tooltipPosition="bottom">
          <span class="material-icons text-base">format_indent_increase</span>
        </button>

        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
          (mousedown)="$event.preventDefault()"
          (click)="decreaseIndent()"
          pTooltip="Decrease indentation"
          tooltipPosition="bottom">
          <span class="material-icons text-base">format_indent_decrease</span>
        </button>

        <!-- TEXT SIZE -->
        <select class="text-xs border rounded px-1 py-1 bg-white transition-colors"
          [value]="currentFontSize"
          [ngClass]="toolbarFieldClass(hasExplicitFontSize)"
          (change)="setFontSize($any($event.target).value)"
          pTooltip="Font size"
          tooltipPosition="bottom">
          <option value="">12 (Default)</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>
          <option value="11">11</option>
          <option value="12">12</option>
          <option value="14">14</option>
          <option value="16">16</option>
          <option value="20">20</option>
          <option value="24">24</option>
          <option value="26">26</option>
        </select>

        <!-- FONT FAMILY -->
        <select class="text-xs border rounded px-1 py-1 bg-white transition-colors"
          [value]="currentFontFamily"
          [ngClass]="toolbarFieldClass(!!currentFontFamily)"
          (change)="setFontFamily($any($event.target).value)"
          pTooltip="Font family"
          tooltipPosition="bottom">
          <option *ngFor="let font of fontFamilyOptions"
            [value]="font.value"
            [style.fontFamily]="font.value || 'inherit'">{{ font.label }}</option>
        </select>

        <!-- HEADINGS -->
        <select class="text-xs border rounded px-1 py-1 bg-white transition-colors"
          [value]="currentHeadingLevel"
          [ngClass]="toolbarFieldClass(!!currentHeadingLevel)"
          (change)="setHeadingLevel($any($event.target).value)"
          pTooltip="Heading level"
          tooltipPosition="bottom">
          <option value="">Normal</option>
          <option value="1">Heading 1</option>
          <option value="2">Heading 2</option>
          <option value="3">Heading 3</option>
          <option value="4">Heading 4</option>
        </select>

        <!-- HYPERLINK -->
        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
          (mousedown)="$event.preventDefault()"
          (click)="insertLink()"
          pTooltip="Insert link"
          tooltipPosition="bottom">
          <span class="material-icons text-base">link</span>
        </button>

        <!-- NOTE LINK -->
        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
          [ngClass]="btn(editor?.isActive('noteLink'))"
          (mousedown)="$event.preventDefault()"
          (click)="openNoteLinkDialog()"
          pTooltip="Link to note"
          tooltipPosition="bottom">
          <span class="material-icons text-base">description</span>
        </button>

        <!-- INSERT IMAGE -->
        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
          (mousedown)="$event.preventDefault()"
          (click)="openImageInsertDialog()"
          pTooltip="Insert image"
          tooltipPosition="bottom">
          <span class="material-icons text-base">image</span>
        </button>

        <!-- ALIGNMENT -->
        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
                [ngClass]="btn(isAlign('left'))"
                (mousedown)="$event.preventDefault()"
          (click)="setAlign('left')"
          pTooltip="Align left"
          tooltipPosition="bottom">
          <span class="material-icons text-base">format_align_left</span>
        </button>

        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
                [ngClass]="btn(isAlign('center'))"
                (mousedown)="$event.preventDefault()"
          (click)="setAlign('center')"
          pTooltip="Align center"
          tooltipPosition="bottom">
          <span class="material-icons text-base">format_align_center</span>
        </button>

        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
                [ngClass]="btn(isAlign('right'))"
                (mousedown)="$event.preventDefault()"
          (click)="setAlign('right')"
          pTooltip="Align right"
          tooltipPosition="bottom">
          <span class="material-icons text-base">format_align_right</span>
        </button>

        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
                [ngClass]="btn(isAlign('justify'))"
                (mousedown)="$event.preventDefault()"
          (click)="setAlign('justify')"
          pTooltip="Justify"
          tooltipPosition="bottom">
          <span class="material-icons text-base">format_align_justify</span>
        </button>

        <!-- TABLE -->
        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
          (mousedown)="$event.preventDefault()"
          (click)="insertTable()"
          pTooltip="Insert table"
          tooltipPosition="bottom">
          <span class="material-icons text-base">table_chart</span>
        </button>

        <div class="relative" (click)="$event.stopPropagation()">
          <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
            (mousedown)="$event.preventDefault()"
            (click)="toggleTableMenu($event)"
            pTooltip="Table actions"
            tooltipPosition="bottom">
            <span class="material-icons text-base">table_rows</span>
          </button>

          <div *ngIf="isTableMenuOpen"
            class="absolute z-20 mt-2 w-56 rounded border bg-white shadow"
            (click)="$event.stopPropagation()">
            <button class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-surface-100"
              [disabled]="!isInTable"
              (mousedown)="$event.preventDefault()"
              (click)="insertRowAbove()"
              pTooltip="Insert row above"
              tooltipPosition="right">
              <span class="material-icons text-base">arrow_upward</span>
              Insert row above
            </button>
            <button class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-surface-100"
              [disabled]="!isInTable"
              (mousedown)="$event.preventDefault()"
              (click)="insertRowBelow()"
              pTooltip="Insert row below"
              tooltipPosition="right">
              <span class="material-icons text-base">arrow_downward</span>
              Insert row below
            </button>
            <button class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-surface-100"
              [disabled]="!isInTable"
              (mousedown)="$event.preventDefault()"
              (click)="insertColumnLeft()"
              pTooltip="Insert column left"
              tooltipPosition="right">
              <span class="material-icons text-base">arrow_back</span>
              Insert column left
            </button>
            <button class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-surface-100"
              [disabled]="!isInTable"
              (mousedown)="$event.preventDefault()"
              (click)="insertColumnRight()"
              pTooltip="Insert column right"
              tooltipPosition="right">
              <span class="material-icons text-base">arrow_forward</span>
              Insert column right
            </button>
            <button class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-surface-100"
              [disabled]="!isInTable"
              (mousedown)="$event.preventDefault()"
              (click)="deleteRow()"
              pTooltip="Delete row"
              tooltipPosition="right">
              <span class="material-icons text-base">remove</span>
              Delete row
            </button>
            <button class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-surface-100"
              [disabled]="!isInTable"
              (mousedown)="$event.preventDefault()"
              (click)="deleteColumn()"
              pTooltip="Delete column"
              tooltipPosition="right">
              <span class="material-icons text-base">remove</span>
              Delete column
            </button>
            <button class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-surface-100"
              [disabled]="!isInTable"
              (mousedown)="$event.preventDefault()"
              (click)="deleteTable()"
              pTooltip="Delete table"
              tooltipPosition="right">
              <span class="material-icons text-base">delete</span>
              Delete table
            </button>
            <div class="flex items-center gap-2 px-3 pt-2 pb-1 text-sm">
              <span class="material-icons text-base">format_color_fill</span>
              <span class="flex-1">Cell color</span>
              <button
                class="text-xs text-surface-400 hover:text-surface-700 flex items-center gap-0.5 border rounded px-1.5 py-0.5 hover:bg-surface-100"
                [disabled]="!isInTable"
                (mousedown)="$event.preventDefault()"
                (click)="clearCellBackgroundColor()"
                pTooltip="Clear cell color"
                tooltipPosition="right">
                <span class="material-icons" style="font-size:13px">format_color_reset</span>
                Clear
              </button>
            </div>
            <div class="px-3 pb-3 space-y-2">
              <!-- Pastel -->
              <div>
                <div class="text-xs text-surface-400 mb-1 font-medium">Pastel</div>
                <div class="flex flex-wrap gap-1">
                  <button *ngFor="let c of cellColorPastel"
                    class="h-5 w-5 rounded-full border border-black/10 hover:ring-2 hover:ring-offset-1 hover:ring-primary-400 transition-shadow"
                    [disabled]="!isInTable"
                    [style.backgroundColor]="c.hex"
                    (mousedown)="$event.preventDefault()"
                    (click)="setCellBackgroundColor(c.hex)"
                    [pTooltip]="c.label"
                    tooltipPosition="top">
                  </button>
                </div>
              </div>
              <!-- Neutral -->
              <div>
                <div class="text-xs text-surface-400 mb-1 font-medium">Neutral</div>
                <div class="flex flex-wrap gap-1">
                  <button *ngFor="let c of cellColorNeutral"
                    class="h-5 w-5 rounded-full border border-black/10 hover:ring-2 hover:ring-offset-1 hover:ring-primary-400 transition-shadow"
                    [disabled]="!isInTable"
                    [style.backgroundColor]="c.hex"
                    (mousedown)="$event.preventDefault()"
                    (click)="setCellBackgroundColor(c.hex)"
                    [pTooltip]="c.label"
                    tooltipPosition="top">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CLEAR -->
        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
          (mousedown)="$event.preventDefault()"
          (click)="clearFormatting()"
          pTooltip="Clear formatting"
          tooltipPosition="bottom">
          <span class="material-icons text-base">format_clear</span>
        </button>

        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
          (mousedown)="$event.preventDefault()"
          (click)="cleanupFormatting()"
          pTooltip="Clean-up formatting"
          tooltipPosition="bottom">
          <span class="material-icons text-base">format_paint</span>
        </button>

        <!-- PASTE AS PLAIN TEXT -->
        <button class="px-1 py-1 rounded border bg-white text-surface-700 border-surface-300 hover:bg-surface-100 flex items-center justify-center"
          (mousedown)="$event.preventDefault()"
          (click)="pasteAsPlainText()"
          pTooltip="Paste as plain text"
          tooltipPosition="bottom">
          <span class="material-icons text-base">content_paste</span>
        </button>
      </div>

      <!-- Collapsible section context menu — view mode (Copy only) -->
      <div
        *ngIf="collapsibleSectionMenuVisible && readOnly"
        class="collapsible-section-menu-panel"
        [style.top.px]="collapsibleSectionMenuPosition.top"
        [style.left.px]="collapsibleSectionMenuPosition.left"
        (click)="$event.stopPropagation()"
        (mousedown)="$event.stopPropagation()">
        <button type="button" class="collapsible-section-menu-item" (click)="onCollapsibleSectionMenuCopy()">
          <span class="pi pi-copy"></span>
          <span>Copy</span>
        </button>
        <button type="button" class="collapsible-section-menu-item" (click)="onCollapsibleSectionMenuExportPdf()">
          <span class="pi pi-file-pdf"></span>
          <span>Export to PDF...</span>
        </button>
      </div>

      <!-- Collapsible section context menu — edit mode (full actions) -->
      <div
        *ngIf="collapsibleSectionMenuVisible && !readOnly"
        class="collapsible-section-menu-panel"
        [style.top.px]="collapsibleSectionMenuPosition.top"
        [style.left.px]="collapsibleSectionMenuPosition.left"
        (click)="$event.stopPropagation()"
        (mousedown)="$event.stopPropagation()">
        <button type="button" class="collapsible-section-menu-item" (click)="onCollapsibleSectionMenuCopy()">
          <span class="pi pi-copy"></span>
          <span>Copy</span>
        </button>
        <button type="button" class="collapsible-section-menu-item" (click)="onCollapsibleSectionMenuDuplicate()">
          <span class="pi pi-clone"></span>
          <span>Duplicate</span>
        </button>
        <button type="button" class="collapsible-section-menu-item" (click)="onCollapsibleSectionMenuInsertLineBefore()">
          <span class="pi pi-plus"></span>
          <span>Insert line before</span>
        </button>
        <button type="button" class="collapsible-section-menu-item" (click)="onCollapsibleSectionMenuInsertLineAfter()">
          <span class="pi pi-plus"></span>
          <span>Insert line after</span>
        </button>
        <button type="button" class="collapsible-section-menu-item" (click)="onCollapsibleSectionMenuCleanup()">
          <span class="pi pi-wrench"></span>
          <span>Clean-up</span>
        </button>
        <button type="button" class="collapsible-section-menu-item" (click)="onCollapsibleSectionMenuClearContents()">
          <span class="pi pi-eraser"></span>
          <span>Clear contents</span>
        </button>
        <button type="button" class="collapsible-section-menu-item delete-action" (click)="onCollapsibleSectionMenuDelete()">
          <span class="pi pi-trash"></span>
          <span>Delete</span>
        </button>
      </div>

      <!-- Image node menu trigger — edit mode -->
      <button
        *ngIf="imageNodeMenuVisible && !readOnly"
        type="button"
        class="image-node-menu-trigger"
        [style.top.px]="imageNodeMenuPosition.top"
        [style.left.px]="imageNodeMenuPosition.left"
        (click)="onImageNodeMenuTriggerClick($event)">
        <span class="pi pi-ellipsis-v"></span>
      </button>

      <!-- Image node context menu — edit mode -->
      <div
        *ngIf="imageNodeMenuExpanded && !readOnly"
        class="image-node-menu-panel"
        [style.top.px]="imageNodeMenuPanelPosition.top"
        [style.left.px]="imageNodeMenuPanelPosition.left"
        (click)="$event.stopPropagation()"
        (mousedown)="$event.stopPropagation()">
        <button type="button" class="image-node-menu-item" (click)="onImageNodeMenuProperties()">
          <span class="pi pi-cog"></span>
          <span>Properties</span>
        </button>
        <button type="button" class="image-node-menu-item" data-testid="image-menu-crop" (click)="onImageNodeMenuCrop()">
          <span class="pi pi-expand"></span>
          <span>Crop</span>
        </button>
        <button type="button" class="image-node-menu-item" (click)="onImageNodeMenuInsertLineBefore()">
          <span class="pi pi-plus"></span>
          <span>Insert line before</span>
        </button>
        <button type="button" class="image-node-menu-item" (click)="onImageNodeMenuInsertLineAfter()">
          <span class="pi pi-plus"></span>
          <span>Insert line after</span>
        </button>
        <button type="button" class="image-node-menu-item delete-action" (click)="onImageNodeMenuDelete()">
          <span class="pi pi-trash"></span>
          <span>Delete</span>
        </button>
      </div>

      <!-- EDITOR -->
      <div #editorHost
        class="tiptap min-h-[160px] pl-6 pr-2 py-2 outline-none border-0
                  bg-surface-0 dark:bg-surface-900 text-surface-900 dark:text-surface-100
                  [&_ul:not([data-type='taskList'])]:list-disc [&_ol]:list-decimal
                  [&_ul:not([data-type='taskList'])]:pl-2 [&_ol]:pl-2
                  [&_ul[data-type='taskList']]:list-none [&_ul[data-type='taskList']]:pl-0
                  [&_ul[data-type='taskList']_li]:list-none [&_ul[data-type='taskList']_li]:pl-0
          [&_table]:border-collapse [&_table]:border [&_table]:border-black
              [&_th]:border [&_td]:border [&_th]:border-black [&_td]:border-black
              [&_th]:px-1 [&_td]:px-1 [&_th]:py-1 [&_td]:py-1 [&_th]:bg-surface-50"
        [class.flex-1]="fillHeight"
        [class.flex]="fillHeight"
        [class.flex-col]="fillHeight"
        [class.editor-fill-height]="fillHeight"
        style="height: auto; overflow: visible;"
            [style.--primary-color]="getPrimaryColor()">
      </div>

      <!-- NOTE LINK DIALOG -->
      <app-note-link-dialog2
        [(visible)]="noteLinkDialogVisible"
        [notes]="allNotes"
        [loading]="notesLoading"
        [initialLinkText]="selectedTextForNoteLink"
        (confirm)="onNoteLinkConfirm($event)"
        (cancel)="onNoteLinkCancel()">
      </app-note-link-dialog2>

      <!-- IMAGE INSERT DIALOG -->
      <app-image-insert-dialog
        [(visible)]="imageInsertDialogVisible"
        [noteId]="noteId"
        [spaceId]="spaceId"
        (insertLinked)="onImageInsertLinked($event)"
        (insertAttachment)="onImageInsertAttachment($event)">
      </app-image-insert-dialog>

      <!-- IMAGE EDIT DIALOG -->
      <app-image-edit-dialog
        [(visible)]="imageEditDialogVisible"
        [attrs]="imageEditAttrs"
        [naturalWidth]="imageEditNaturalWidth"
        [naturalHeight]="imageEditNaturalHeight"
        [fileSizeBytes]="imageEditFileSizeBytes"
        [filename]="imageEditFilename"
        (save)="onImageEditSave($event)">
      </app-image-edit-dialog>

      <!-- IMAGE CROP DIALOG -->
      <app-image-crop-dialog
        [(visible)]="imageCropDialogVisible"
        [src]="imageCropSrc"
        [initialCrop]="imageCropInitial"
        (cropApplied)="onImageCropApplied($event)">
      </app-image-crop-dialog>

      <!-- INLINE TASK: OWNER PICKER -->
      <p-dialog
        header="Task owner"
        [(visible)]="taskOwnerDialogVisible"
        [modal]="true"
        [dismissableMask]="true"
        [draggable]="false"
        [resizable]="false"
        [style]="{ width: '360px', maxWidth: '92vw' }"
        appendTo="body"
        (onHide)="onTaskOwnerDialogHide()">
        <div class="flex flex-col gap-2" data-testid="task-owner-picker">
          @if (taskOwnerCurrentIneligible) {
            <p class="m-0 text-sm text-red-600 dark:text-red-400" role="alert">
              <span class="pi pi-exclamation-triangle mr-1" aria-hidden="true"></span>
              The current owner no longer has access to this note. Pick someone else or clear the owner.
            </p>
          }
          <p-listbox
            [options]="taskOwnerOptions"
            optionLabel="name"
            optionValue="id"
            [optionDisabled]="'ineligible'"
            [ngModel]="taskOwnerSelection"
            (onChange)="onTaskOwnerPicked($event.value)"
            [filter]="taskOwnerOptions.length > 7"
            filterPlaceholder="Find a member"
            ariaLabel="Assign the task to"
            [listStyle]="{ 'max-height': '50vh' }"
            styleClass="w-full">
            <ng-template let-option #item>
              <div class="flex min-h-8 w-full items-center gap-2" [attr.data-testid]="'task-owner-option'">
                <span class="pi" [ngClass]="option.id === null ? 'pi-user-minus' : option.ineligible ? 'pi-exclamation-triangle text-red-600 dark:text-red-400' : 'pi-user'" aria-hidden="true"></span>
                <span class="min-w-0 flex-1 truncate">{{ option.name }}</span>
                @if (option.ineligible) {
                  <span class="text-xs text-red-600 dark:text-red-400">no access</span>
                }
              </div>
            </ng-template>
          </p-listbox>
          @if (taskOwnerListNote) {
            <p class="m-0 text-xs text-surface-500 dark:text-surface-400">{{ taskOwnerListNote }}</p>
          }
        </div>
      </p-dialog>

      <!-- INLINE TASK: DUE DATE PICKER -->
      <p-dialog
        header="Due date"
        [(visible)]="taskDueDialogVisible"
        [modal]="true"
        [dismissableMask]="true"
        [draggable]="false"
        [resizable]="false"
        [style]="{ width: 'auto', maxWidth: '96vw' }"
        appendTo="body"
        (onHide)="onTaskDueDialogHide()">
        <div class="flex flex-col items-center gap-3" data-testid="task-due-picker">
          <div class="flex w-full flex-wrap justify-center gap-2">
            <p-button label="Today" size="small" severity="secondary" [outlined]="true" (onClick)="setTaskDueDate('today')"></p-button>
            <p-button label="Tomorrow" size="small" severity="secondary" [outlined]="true" (onClick)="setTaskDueDate('tomorrow')"></p-button>
            <p-button label="In a week" size="small" severity="secondary" [outlined]="true" (onClick)="setTaskDueDate('next-week')"></p-button>
          </div>
          <p-datepicker
            [inline]="true"
            [(ngModel)]="taskDueDraft"
            (onSelect)="setTaskDueDate($event)"
            [showWeek]="false"
            ariaLabel="Due date">
          </p-datepicker>
        </div>
        <ng-template #footer>
          <div class="flex w-full justify-between gap-2">
            <p-button
              label="Clear"
              icon="pi pi-times"
              severity="danger"
              [text]="true"
              [disabled]="!taskDueCurrent"
              (onClick)="setTaskDueDate(null)"></p-button>
            <p-button label="Cancel" severity="secondary" (onClick)="taskDueDialogVisible = false"></p-button>
          </div>
        </ng-template>
      </p-dialog>

      <!-- HYPERLINK DIALOG -->
      <p-dialog
        header="Insert Link"
        [(visible)]="linkDialogVisible"
        [modal]="true"
        [draggable]="false"
        [resizable]="false"
        [style]="{ width: '420px', maxWidth: '92vw' }"
        appendTo="body">
        <div class="flex flex-col gap-3">
          <div class="flex flex-col gap-1">
            <label for="linkLabel" class="text-sm font-semibold">Label</label>
            <input
              id="linkLabel"
              pInputText
              type="text"
              [(ngModel)]="linkLabel"
              placeholder="Link text"
              class="w-full" />
          </div>
          <div class="flex flex-col gap-1">
            <label for="linkUrl" class="text-sm font-semibold">URL</label>
            <input
              id="linkUrl"
              pInputText
              type="url"
              [(ngModel)]="linkUrl"
              placeholder="https://"
              class="w-full" />
          </div>
        </div>
        <ng-template pTemplate="footer">
          <div class="flex gap-2 justify-end">
            <p-button
              label="Cancel"
              severity="secondary"
              (onClick)="onLinkDialogCancel()"></p-button>
            <p-button
              label="OK"
              [disabled]="!linkLabel.trim() || !linkUrl.trim()"
              (onClick)="onLinkDialogConfirm()"></p-button>
          </div>
        </ng-template>
      </p-dialog>
    </div>
